export default {
  acceptedCookieVersion: "1",
  googleClientId: '656331298441-8bb78tsu8el4gv4p5rbvne01r2pbdn88.apps.googleusercontent.com',
  googleGtagId: 'G-GHP20LYE47',
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,}$/,
  passwordText: 'The password must be at least 10 characters long containing the following: upper case letters, lower case letters, and digits.',
  tokenRefreshNetworkFailureRetrySeconds: 30,
  tokenRefreshPreexpirySeconds: 120 
}